// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"common_primaryColor__pKRZC","btnTxt":"common_btnTxt__BWPPh"};